import { useEffect, useMemo, useState } from 'react';
import { useAmzContext } from 'src/contexts/AmzContext';
import { useFkContext } from 'src/contexts/FkContext';
import { useCommonContext } from 'src/contexts/CommonContext';
import { ReactComponent as SnapshotIcon } from 'src/assets/images/common/snapshot-white.svg';
import { ReactComponent as AmazonIcon } from 'src/assets/images/common/amazon-white.svg';
import { ReactComponent as MasterOverviewIcon } from 'src/assets/images/common/master-overview.svg';
import { ReactComponent as DaypartIconIcon } from 'src/assets/images/common/daypart.svg';
import { ReactComponent as DashboardIcon } from 'src/assets/images/common/ams-dash.svg';
import { ReactComponent as HectorGptIcon } from 'src/assets/images/common/chat.svg';
import { ReactComponent as DspIcon } from 'src/assets/images/dsp/digital-transformation.svg';
import { ReactComponent as AmcDashboardIcon } from 'src/assets/images/common/dashboard.svg';
import { ReactComponent as AmckeyIconwhite } from 'src/assets/images/common/calender-white.svg';
import { ReactComponent as BillingMenuIcon } from 'src/assets/images/common/billing-menu-icon.svg';
import { ReactComponent as BillingPaymentsIcon } from 'src/assets/images/common/billing-payment.svg';
import { Award, Clock, Search, Cpu, Target, ShoppingBag } from 'react-feather';
import { ReactComponent as UserActivityIcon } from 'src/assets/images/common/harvesting.svg';
import { ALLOWED_PROFILE, CHATGPT_PROFILES } from 'src/views/pages/audience-report/utils';
import newMenuItems from 'src/new-menu-items';
import useApi from 'src/hooks/useApi';
import services from 'src/api/service';
import BidRuleIcon from 'src/assets/icons/BidRuleIcon';
import BudgetRuleIcon from 'src/assets/icons/BudgetRuleIcon';
import PlacementRuleIcon from 'src/assets/icons/PlacementRuleIcon';
import SearchTermRuleIcon from 'src/assets/icons/SearchTermRuleIcon';
import StatusRuleIcon from 'src/assets/icons/StatusRuleIcon';
import SearchTermRuleNegationIcon from 'src/assets/icons/SearchTermRuleNegationIcon';
import { ReactComponent as MarketingStreamIcon } from 'src/assets/images/common/ams-icon.svg';
import { ReactComponent as ClientAccessIcon } from 'src/assets/images/common/user-input-menu.svg';
import useDspDetails from 'src/views/pages/dsp-payment/hooks/useGetWalletDetails'
import FirstPartyIcon from 'src/assets/icons/FirstPartyIcon';
import CampaignGenration from 'src/assets/icons/CampaignGenration';
import { isUserFromAllowedDomain } from 'src/utils/emailUtils';
import { ReactComponent as FlipkartIcon } from 'src/assets/images/common/flipkart-white.svg';
import { useIsFromFlipkartEnv } from 'src/hooks/useIsFromFlipkartUrl';
import RankingNavIcon from 'src/assets/icons/Ranking';

import { 
  getPlatformStates, 
  buildMenuData 
} from 'src/utils/menuBuilderUtils';
import { APP_FEATURE_CONFIG } from 'src/config/constant';

const useNewMenuItems = () => {
  const [menuItems, setMenuItems] = useState([]);
  const { commonState } = useCommonContext();
  const { amzState } = useAmzContext();
  const { fkState } = useFkContext();
  const authToken = JSON.parse(localStorage.getItem('User'));
  const getProfile = JSON.parse(sessionStorage.getItem('selectedProfileId'));
  const profileIdCheck = useApi(services.postService);
  const { dspAccount } = useDspDetails();

  const [amcMenus, setAmcMenus] = useState([])
  
  const isFromFlipkartEnv = useIsFromFlipkartEnv()
  const isAmazon = window.location.href.indexOf('/amazon') > -1

  const RANKING_ENABLED_PROFILE_IDS = [
    '2696770097145802',
    '3293073905495507',
    '3679505750118496'
  ];

  const RANKING_ENABLED_REGIONS  = [
    'US',
    'IN',
    'UK',
    'CA',
    'DE',
    'ES',
    'FR',
  ]

  const RankingDashboardMenuItems = RANKING_ENABLED_REGIONS?.includes(getProfile?.countryCode) ? [
    { label: 'Ranking 360', icon: <RankingNavIcon />, path: '/amazon-ranking-dashboard' },
  ] : [];

  const GENAI_PROFILE_IDS = [
    '2696770097145802',
    '4136588997704567', 
    '4414737971071757',
    '1218262740109787',
    '1749890218914424'
  ];

  const isAccessForAmazon = useMemo(() => {

    // Default needs to show all the options = []
    if(APP_FEATURE_CONFIG?.AMAZON_SUB_PERMISSIONS_CHECK === false) {
      return { showDsp: true, showAmc: true, showSponsoredAds: true }
    }

    const permissions = getProfile?.permissions;

    if (!permissions || (Array.isArray(permissions) && permissions?.length === 0) || permissions === 0) {
      return { showDsp: true, showAmc: true, showSponsoredAds: true };
    }

    let showDsp = false;
    let showAmc = false;
    let showSponsoredAds = false;

    if (Array.isArray(permissions) && permissions?.length > 0) {
      if (permissions.includes('DSP')) showDsp = true;
      if (permissions.includes('AMC')) showAmc = true;
      if (permissions.includes('Sponsored Ads')) showSponsoredAds = true;
    } else {
      showDsp = true;
      showAmc = true;
      showSponsoredAds = true;
    }
    console.log('showDsp, showAmc, showSponsoredAds', showDsp, showAmc, showSponsoredAds)
    return { showDsp, showAmc, showSponsoredAds };
  }, [getProfile]);
  
  useEffect(() => {
    if(getProfile && getProfile?.profileId) {
      profileIdCheck.request({
        url: '/amc/amcOnboardedusers',
        nodeAPI: 1,
        payload: {}
      });
    }
  }, []);

  useEffect(() => {
    const { loading, data } = profileIdCheck;
    const restrictedAmcCountries = (getProfile?.countryCode == 'IN' || getProfile?.countryCode == 'US');
    const shouldAddAudienceAndInsights = !loading  && data && data.success === true && data.message === 'success' && data.data === true ;
    const amcMenuItems = [
      {
        label: 'Console',
        icon: <ClientAccessIcon />,
        path: getProfile?.dsp_only ? '/amazon-audience-instance-register/create' : '/amazon-audience-instance',
      },
    ];

    if (shouldAddAudienceAndInsights) {
      const getProfileCopy = JSON.parse(sessionStorage.getItem('selectedProfileId'))
      if(getProfileCopy && getProfileCopy?.profileId) {
        sessionStorage.setItem('selectedProfileId', JSON.stringify({
          ...getProfileCopy,
          amcAvailable: true
        }));
      }
      amcMenuItems.push(
        {
          label: 'Audience',
          icon: <AmcDashboardIcon />,
          path: '/amazon-audience-report',
        },
        {
          label: 'Insights',
          icon: <AmckeyIconwhite />,
          path: '/amazon-insights',
        },
        {
          label: 'First Party Data',
          icon: <FirstPartyIcon />,
          path: '/amazon-first-party-data',
          isBeta: true,
        }
      );
    }

    setAmcMenus(
      (((shouldAddAudienceAndInsights || restrictedAmcCountries) && data?.enabledAmc) || data?.enabledAmc) ? [
        {
          title: 'AMC',
          icon: <AmazonIcon />,
          items: amcMenuItems,
        },
      ] : []
    );
  }, [profileIdCheck.loading]);

  useEffect(() => {
    const isSuperAdmin = process.env.REACT_APP_ADMIN_ACCESS_EMAIL.indexOf(authToken?.email) > -1 || false;
    const platformStates = getPlatformStates(commonState);

    console.log("useNewMenuItems",{
      ...platformStates,
      amzState,
      fkState,
      getProfile
    });

    if (isFromFlipkartEnv) {
      setMenuItems([newMenuItems[1]]);
      return;
    }
    
    const clientMenus = [];
    let menuData = [];
    
    const onlyMcp = authToken?.planDetails?.only_mcp === true || authToken?.metaDetails?.offering === 'mcp';

    console.log("useNewMenuItems onlyMcp", onlyMcp);

    // Amazon Menu Configuration
    if (amzState || onlyMcp) {
      if (onlyMcp) {
        clientMenus.push({
          title: 'Amazon',
          icon: <AmazonIcon />,
          items: [
            { label: 'Brands', icon: <DashboardIcon />, path: '/profile' },
            { label: 'MCP', icon: <AmazonIcon />, path: '/connect-mcp' },
          ],
        });
      } else {
      const amazonMenu = {
        title: 'Amazon',
        icon: <AmazonIcon />,
        items: ((!getProfile?.ams?.connected && platformStates.amcState == true) && (!getProfile?.ams?.connected && getProfile?.amcConnected == true)) ? 
        [ ...(profileIdCheck?.data?.enabledAmc == false ? [] : amcMenus.length ? amcMenus : [{
          title: 'AMC',
          icon: <AmazonIcon />,
          items: [
            {
              label: 'Console',
              icon: <ClientAccessIcon />,
              path: getProfile?.dsp_only ? '/amazon-audience-instance-register/create' : '/amazon-audience-instance',
            }
          ]
        }]), ...(getProfile?.dsp?.length == 0 ? [
          { title: 'DSP', icon: <DspIcon />,
            items: [
              { label: 'Console', icon: <DspIcon />, path: '/amazon-dsp' }
            ]
           }
        ] : getProfile?.dsp?.length > 0 || (getProfile?.dspId) ? [
          { title: 'DSP', icon: <DspIcon />,
            items: [
              { label: 'Console', icon: <DspIcon />, path: dspAccount?.amazonManaged === 'No' || dspAccount?.amazonManaged === 'no' ? '/amazon-dsp/campaign' : '/amazon-dsp/reports' },
              ...(dspAccount?.dspId && (dspAccount?.amazonManaged === 'No' || dspAccount?.amazonManaged === 'no') ? [
                { label: 'Automation Rules', icon: <BudgetRuleIcon fillColor='#fff' height="20px" width="20px" />, path: '/amazon-dsp-automated-rules/budget', isBeta: true },
                { label: 'Live Reports', icon: <MarketingStreamIcon />,  path: '/amazon-dsp/marketing-stream' },
                ...(isUserFromAllowedDomain() ? [{ label: 'Dayparting', icon: <DaypartIconIcon />, path: '/amazon-dsp-dayparting-performance', isBeta: true }] : []),
                ...(dspAccount?.dspId && (authToken?.isAgency || isSuperAdmin) ? [{ label: 'Billing & Payments', icon: <BillingMenuIcon />, path: '/billing-payments?view=admin' },
                ...(isSuperAdmin ? [{ label: 'Logs', icon: <AmcDashboardIcon />, path: '/amazon-dsp-logs' }] : []),
                ] : []),
              ] : [])
            ],
          }
        ] : [])] : (getProfile?.dsp_only) ? [
          ...(profileIdCheck?.data?.enabledAmc ? amcMenus.length ? amcMenus : [{
            title: 'AMC',
            icon: <AmazonIcon />,
            items: [
              {
                label: 'Console',
                icon: <ClientAccessIcon />,
                path: '/amazon-audience-instance-register/create',
              }
            ]
          }] : []),
          { title: 'DSP', icon: <DspIcon />,
            items: [
              { label: 'Console', icon: <DspIcon />, path: dspAccount?.amazonManaged === 'No' || dspAccount?.amazonManaged === 'no' ? '/amazon-dsp/campaign' : '/amazon-dsp/reports'  },
              ...(dspAccount?.dspId && (dspAccount?.amazonManaged === 'No' || dspAccount?.amazonManaged === 'no') ? [
                { label: 'Automation Rules', icon: <BudgetRuleIcon fillColor='#fff' height="20px" width="20px" />, path: '/amazon-dsp-automated-rules/budget' },
                { label: 'Live Reports', icon: <MarketingStreamIcon />,  path: '/amazon-dsp/marketing-stream' },
                ...(isUserFromAllowedDomain() ? [{ label: 'Dayparting', icon: <DaypartIconIcon />, path: '/amazon-dsp-dayparting-performance' }] : []),
                ...(dspAccount?.dspId && (authToken?.isAgency || isSuperAdmin) ? [{ label: 'Billing & Payments', icon: <BillingMenuIcon />, path: '/billing-payments?view=admin' },
                ...(isSuperAdmin ? [{ label: 'Logs', icon: <AmcDashboardIcon />, path: '/amazon-dsp-logs' }] : []),
                ] : []),
              ] : [])
            ],
          },
        ]
          :
          [
            { label: 'Targeting 360', icon: <DashboardIcon />, path: '/amazon/targeting' },
            { label: 'Change History', icon: <UserActivityIcon />, path: '/amazon/cpc-job-listing' },
            { label: 'Hourly Performance - Live', icon: <MarketingStreamIcon />, path: '/amazon/marketing-stream' },
            { label: 'Snapshot', icon: <SnapshotIcon />, path: '/amazon-snapshot' },
            { label: 'Master Overview', icon: <MasterOverviewIcon />, path: '/amazon-master-overview' },
            { label: 'Dayparting', icon: <DaypartIconIcon />, path: '/amazon-dayparting-performance' },
            ...RankingDashboardMenuItems,
            ...(authToken?.email === 'mayank@hectorai.live' ? [{ label: 'Dayparting Tracking', icon: <Clock height="22px" width="22px" />, path: '/amazon-dayparting-tracking' }] : []),
            // { label: 'Ad Account History', icon: <Clock height="22px" width="22px" />, path: '/amazon-history' },
            // ...(CHATGPT_PROFILES?.includes(String(getProfile?.profileId)) || CHATGPT_PROFILES?.length === 0 ? [
            //   {
            //     label: 'Hector GPT',
            //     icon: <HectorGptIcon />,
            //     path: '/amazon-chatgpt',
            //   }
            // ] : []),
            ...(getProfile?.seller?.connected == true ? [
              { label: 'SQP', icon: <Search />, path: '/amazon/search-query-performance', isBeta: true },
            ] : []),
            { title: 'DSP', icon: <DspIcon />,
              items: [
              { label: 'Console', icon: <DspIcon />, path: dspAccount?.amazonManaged === 'No' || dspAccount?.amazonManaged === 'no' ? '/amazon-dsp/campaign' : '/amazon-dsp/reports'  },
              ...(dspAccount?.dspId && (dspAccount?.amazonManaged === 'No' || dspAccount?.amazonManaged === 'no')? [
                { label: 'Automation Rules', icon: <BudgetRuleIcon fillColor='#fff' height="20px" width="20px" />, path: '/amazon-dsp-automated-rules/budget' },
                { label: 'Live Reports', icon: <MarketingStreamIcon />,  path: '/amazon-dsp/marketing-stream' },
                ...(isUserFromAllowedDomain() ? [{ label: 'Dayparting', icon: <DaypartIconIcon />, path: '/amazon-dsp-dayparting-performance' }] : []),
                ...(dspAccount?.dspId && (authToken?.isAgency || isSuperAdmin) ? [{ label: 'Billing & Payments', icon: <BillingMenuIcon />, path: '/billing-payments?view=admin' },
                ...(isSuperAdmin ? [{ label: 'Logs', icon: <AmcDashboardIcon />, path: '/amazon-dsp-logs' }] : []),
                ] : []),
              ] : [])
            ],
            },
            ...(amcMenus.length ? amcMenus : []),
            // { label: 'DSP', icon: <DspIcon />, path: '/amazon-dsp' },
            // (getProfile?.accessLevel?.toLowerCase() == 'manager' && authToken?.isRuleEnabled == true) || (authToken?.isRuleEnabled == true && String(authToken?.email).toLowerCase().indexOf('@pexpo') > -1)
          ...(isSuperAdmin ||  authToken?.isRuleEnabled == true ? [{
              title: 'Automation Rules',
              icon: <AmazonIcon />,
            items: [
              // ...(String(authToken?.email).toLowerCase().indexOf('@hectorai') > -1 || String(authToken?.email).toLowerCase().indexOf('@neon') > -1 || String(authToken?.email).toLowerCase().indexOf('@sagusco') > -1 || String(authToken?.email).toLowerCase() == 'reportsclicklv@gmail.com' || String(getProfile?.profileId) === '607072374149765'? [
              //   { label: 'Optimization Dashboard', icon: <Award fillColor='#fff' height="20px" width="20px" />, path: '/amazon-automated-rules/master/templates', isBeta: true },
              // ] : []),
              { label: 'Optimization Dashboard', icon: <Award fillColor='#fff' height="20px" width="20px" />, path: '/amazon-automated-rules/master/templates', isBeta: true },
              { label: 'Budget', icon: <BudgetRuleIcon fillColor='#fff' height="20px" width="20px" />, path: '/amazon-automated-rules/budget' },
              { label: 'Bid', icon: <BidRuleIcon fillColor='#fff' height="20px" width="20px" />, path: '/amazon-automated-rules/bid' },
              { label: 'Status', icon: <StatusRuleIcon fillColor='#fff' height="20px" width="20px"/>, path: '/amazon-automated-rules/status' },
              { label: 'Placement', icon: <PlacementRuleIcon fillColor='#fff' height="20px" width="20px"/>, path: '/amazon-automated-rules/placement' },
              { label: 'ST Negation', icon: <SearchTermRuleNegationIcon fillColor='#fff' height="20px" width="20px"/>, path: '/amazon-automated-rules/searchterm-negation' },
              { label: 'ST Harvesting', icon: <SearchTermRuleIcon fillColor='#fff' height="20px" width="20px"/>, path: '/amazon-automated-rules/searchterm-harvesting' },
              ],
            }] : []),
            ...([
              { label: 'Smart Campaigns', icon: <Award height="22px" width="22px" />, path: '/amazon/smart-campaigns', isBeta: true }
            ]),
            ...(getProfile?.genaiEnabled ? [
              { label: 'GenAI Smart Breakdown', icon: <Cpu height="22px" width="22px" />, path: '/genai/openchat/campaign', isBeta: true }
            ] : []),
            ...(isUserFromAllowedDomain() ? [
              { label: 'Dayparting Error Tracking', icon: <UserActivityIcon />, path: '/master-error-tracking/dayparting' },
              // { label: 'Rule-Based Error Tracking', icon: <UserActivityIcon />, path: '/master-error-tracking/amazon/rule-based' },
            ] : []),
            ...(isUserFromAllowedDomain() ? [
              {
                label: 'Brands Dashboard',
                icon: <DashboardIcon />,
                path: '/brands-dashboard'
              }
            ] : []) 
          ],
      };

      let filteredAmazonMenu = amazonMenu;
      if (isAmazon && isAccessForAmazon) {
        const { showDsp, showAmc, showSponsoredAds } = isAccessForAmazon;
        filteredAmazonMenu = {
          ...amazonMenu,
          items: (amazonMenu.items || []).filter((item) => {
            if (item?.title === 'AMC') return showAmc;
            if (item?.title === 'DSP') return showDsp;
            return showSponsoredAds;
          })
        };
      }

      clientMenus.push(filteredAmazonMenu);
      }
    }

    // Build menu data using the new utility functions
    menuData = buildMenuData(platformStates, isSuperAdmin, clientMenus, getProfile);

    console.log("New Menu Data",menuData);

    setMenuItems(menuData);

    return () => {
      setMenuItems([]);
    };
  }, [amzState.amazonProfiles, commonState, amcMenus, dspAccount?.dspId]);

  return { menuItems };
};

export default useNewMenuItems;
